module.exports = __webpack_public_path__ + "img/img-card-02.513e86a6.png";